import axios from "../axios";

export async function deleteStorage(payload) {
  return axios
    .delete(`/inventory/storages/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function createStorage(payload) {
  return axios
    .post(`/inventory/storages`, { inventory_storage: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function updateStorage(payload) {
  return axios
    .put(`/inventory/storages/` + payload.id, { inventory_storage: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchStorages() {
  return axios
    .get(`/inventory/storages`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching storages:", error);
      if (error.response) {
        return { error: true, status: error.response.status, data: error.response.data };
      } else if (error.request) {
        return { error: true, status: 0, message: "Network error" };
      } else {
        return { error: true, status: 500, message: error.message };
      }
    });
}

export async function fetchStorage(payload) {
  // payload is only ID
  return axios
    .get(`/inventory/storages/` + payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
